import { z } from 'zod';

const MAX_COUNT = 32767;

// Empty means "no informado" (null); 0 is a real value
const optionalCount = z
  .string()
  .trim()
  .regex(/^\d*$/, 'Ingresá un número entero mayor o igual a 0')
  .refine((value) => value === '' || Number(value) <= MAX_COUNT, `Máximo ${MAX_COUNT}`);

const optionalText = (max: number) => z.string().trim().max(max, `Máximo ${max} caracteres`);

// One row of a municipal list; empty strings are converted to null in form-mapping.utils
export const preRegisteredAccommodationSchema = z.object({
  establishmentName: z
    .string()
    .trim()
    .min(1, 'La denominación comercial es obligatoria')
    .max(255, 'Máximo 255 caracteres'),
  localityId: z.string(),
  address: optionalText(255),
  establishmentPhone: optionalText(50),
  contactName: optionalText(100),
  contactPhone: optionalText(50),
  places: optionalCount,
  rooms: optionalCount,
  legalInstrument: optionalText(500),
  observations: z.string(),
});

export type PreRegisteredAccommodationFormValues = z.infer<typeof preRegisteredAccommodationSchema>;
